module.exports = __webpack_public_path__ + "img/AsphaltPaver.fa991c0b.png";